// JS bundle 2: efectos y scripts personalizados
import 'script-loader!../js/wow.min.js';
import 'script-loader!../js/script.js';
import 'script-loader!../js/template.js';
